export const navItems = [
  { label: "头版", href: "#headline" },
  { label: "图鉴原图", href: "#gallery" },
  { label: "视频集", href: "#videos" },
  { label: "流出时间线", href: "#timeline" },
  { label: "追更热榜", href: "#hot" },
  { label: "常见问题", href: "#faq" },
];

export const featuredItems = [
  {
    tag: "本日头版",
    title: "九色黑料图片、九色黑料视频今日持续更新，截图原图按页面分门别类",
    summary:
      "点进任一专区就能按图索骥：新到货的图片与视频细节被打散归档，想看原图级画面的网友不必再在一屏里来回翻找。",
    meta: "2 小时前 · 头版速递",
  },
  {
    title: "原图级画面怎么看才不糊？先分清批次再点开",
    summary: "同一批流出内容里，清晰度与完整度差异明显，先按日期与题材分层，再决定从哪一页看起。",
    meta: "更新于 09:40",
  },
  {
    title: "九色黑料截图也能反查来源，关键帧对不上就说明版本旧了",
    summary: "截图细节是否对得上日期与场景，决定这条内容到底算不算最新流出。",
    meta: "昨日 · 归档复盘",
  },
];

export const galleryItems = [
  {
    cover: "https://readdy.ai/api/search-image?query=a%20moody%20editorial%20magazine%20cover%20art%20of%20a%20glowing%20smartphone%20screen%20casting%20warm%20light%20over%20scattered%20printed%20photographs%20on%20a%20dark%20wooden%20desk%20with%20dramatic%20chiaroscuro%20and%20deep%20amber%20tones%20and%20cinematic%20shallow%20depth%20of%20field&width=800&height=1000&seq=jiuse-g1&orientation=portrait",
    tag: "图片专区",
    title: "本批原图 · 暗部细节版",
    summary: "按页面分好的九色黑料图片，点开即看原图级画面，暗部与边缘细节更完整。",
    views: "3.2 万次浏览",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=close%20up%20editorial%20photography%20of%20an%20open%20archive%20folder%20with%20stacked%20photo%20prints%20and%20a%20magnifying%20glass%20on%20warm%20paper%20desk%20with%20soft%20window%20light%20and%20cream%20and%20red%20tonal%20palette%20and%20high%20texture%20detail&width=800&height=1000&seq=jiuse-g2&orientation=portrait",
    tag: "图片专区",
    title: "翻页整理 · 按日期归组",
    summary: "日期相近的画面被归到同一页，避免新旧内容混在一起误导判断。",
    views: "2.1 万次浏览",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=a%20cinematic%20still%20of%20a%20laptop%20screen%20reflecting%20against%20a%20dark%20room%20wall%20with%20blue%20and%20warm%20ambient%20contrast%20and%20mysterious%20silhouette%20shadows%20and%20editorial%20night%20scene%20photography%20style&width=800&height=1000&seq=jiuse-g3&orientation=portrait",
    tag: "画面解析",
    title: "反查细节 · 关键帧对焦",
    summary: "截图的边缘与光源对不上画面，通常代表流传的只是压缩旧版。",
    views: "1.8 万次浏览",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=editorial%20product%20photography%20of%20a%20mobile%20phone%20held%20over%20newsprint%20papers%20with%20a%20small%20locked%20icon%20glow%20and%20warm%20table%20lamp%20light%20and%20soft%20shadows%20and%20minimal%20desk%20composition&width=800&height=1000&seq=jiuse-g4&orientation=portrait",
    tag: "归档旧档",
    title: "漏网旧档 · 高清补档",
    summary: "早期批次的高清版本被重新补全，点击即可对比旧版缺失的画面。",
    views: "1.5 万次浏览",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=artistic%20still%20life%20of%20security%20camera%20feed%20style%20monitor%20showing%20grainy%20footage%20silhouette%20with%20timestamp%20overlay%20in%20dark%20control%20room%20with%20muted%20green%20and%20black%20tones&width=800&height=1000&seq=jiuse-g5&orientation=portrait",
    tag: "视频截图",
    title: "截帧图 · 一帧一帧看",
    summary: "从视频里拆出的关键帧单独成页，画面细节放大后依然清楚。",
    views: "9.6 千次浏览",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=elegant%20editorial%20photography%20of%20a%20stack%20of%20aged%20film%20negatives%20and%20contact%20sheets%20on%20a%20warm%20studio%20table%20with%20soft%20directional%20light%20and%20vintage%20analog%20archive%20feeling&width=800&height=1000&seq=jiuse-g6&orientation=portrait",
    tag: "影像旧档",
    title: "影像胶片 · 清晰重建",
    summary: "模糊的旧截图用细节重建后重发，关键部位信息量明显提升。",
    views: "7.4 千次浏览",
  },
];

export const videoItems = [
  {
    cover: "https://readdy.ai/api/search-image?query=wide%20cinematic%20editorial%20scene%20of%20a%20television%20screen%20glowing%20in%20a%20dark%20living%20room%20with%20warm%20and%20cool%20light%20contrast%20and%20soft%20smoke%20and%20dramatic%20film%20still%20atmosphere&width=900&height=560&seq=jiuse-v1&orientation=landscape",
    tag: "视频集",
    title: "本段视频 · 画质修复版",
    summary: "把原始低清片段做了画质修复，动态细节比截图更清楚。",
    duration: "06:42",
    views: "4.6 万次观看",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=editorial%20night%20scene%20of%20a%20film%20projector%20beam%20cutting%20through%20darkness%20onto%20a%20wall%20with%20dust%20particles%20and%20warm%20amber%20light%20and%20cinematic%20depth&width=900&height=560&seq=jiuse-v2&orientation=landscape",
    tag: "视频集",
    title: "流转片段 · 完整拼接",
    summary: "把多段不连贯的片段按时间线拼回，前后因果一下清晰了。",
    duration: "11:09",
    views: "3.1 万次观看",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=backlit%20silhouette%20of%20a%20person%20watching%20a%20glowing%20phone%20screen%20in%20a%20dim%20room%20with%20rim%20lighting%20and%20editorial%20portrait%20atmosphere%20and%20grainy%20film%20texture&width=900&height=560&seq=jiuse-v3&orientation=landscape",
    tag: "视频集",
    title: "访谈原声 · 视频加字幕",
    summary: "画面之外的声音信息也整理进字幕，视频细节更好抓。",
    duration: "18:27",
    views: "2.4 万次观看",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=high%20detail%20macro%20photography%20of%20a%20camera%20lens%20reflection%20with%20warm%20studio%20lights%20and%20abstract%20bokeh%20and%20modern%20video%20production%20set%20feeling&width=900&height=560&seq=jiuse-v4&orientation=landscape",
    tag: "视频集",
    title: "画中画 · 多机位对比",
    summary: "同一事件的多机位画面并排比对，哪些是原版一目了然。",
    duration: "09:33",
    views: "1.9 万次观看",
  },
  {
    cover: "https://readdy.ai/api/search-image?query=moody%20editorial%20still%20of%20a%20hand%20pressing%20play%20on%20a%20retro%20recorder%20device%20beside%20a%20stack%20of%20audio%20reels%20with%20warm%20desk%20lamp%20and%20vintage%20archive%20mood&width=900&height=560&seq=jiuse-v5&orientation=landscape",
    tag: "视频集",
    title: "音频归档 · 口述细节",
    summary: "视频之外的旁白被单独拆出，文字逐句对照更方便。",
    duration: "24:15",
    views: "1.2 万次观看",
  },
];

export const flowItems = [
  { date: "09月06日", time: "11:20", label: "新增图片 6 张 · 视频 1 段", title: "九色黑料图片专区补入最新批次，原图级画面已按日期归组", note: "九色黑料截图同步更新，翻到页尾即可看新增部分。" },
  { date: "09月06日", time: "09:40", label: "批次重组", title: "旧批次高清补档完成，压缩版截图可一键对比原图", note: "九色黑料图片细节得到修复，模糊位置信息量明显提升。" },
  { date: "09月05日", time: "21:05", label: "视频更新", title: "本段流转片段完成拼接，前后文因果终于连上", note: "视频动态与截图交叉验证，时长信息已修正。" },
  { date: "09月05日", time: "15:30", label: "新增截图 12 张", title: "九色黑料截图按页新开一档，关键帧逐张放大", note: "想找截图、照片或视频细节的网友可直接从本页开翻。" },
  { date: "09月04日", time: "19:12", label: "画面修复", title: "漏网旧档回归，边缘暗部细节补全到原图级", note: "归档旧档页内已同步，旧版缺失画面现已补上。" },
  { date: "09月04日", time: "10:48", label: "分区整理", title: "视频截图单独成页，避免与整段画面混在一起", note: "按页面分好的内容让查找更省力，点开就能看。" },
  { date: "09月03日", time: "22:37", label: "头版速递", title: "本周更新告一段落，整理目录已发布至时间线", note: "所有新增内容的目录会在此页持续汇总。" },
  { date: "09月02日", time: "14:26", label: "批次核验", title: "旧版截图与日期对不上，疑似流通的是压缩版本", note: "反查来源的说明已补进常见问题专区。" },
];

export const hotRankItems = [
  { rank: 1, title: "【头版】本批九色黑料图片、视频细节合集", views: "今日 4.6 万" },
  { rank: 2, title: "九色黑料截图原图与压缩版逐帧对比", views: "今日 3.1 万" },
  { rank: 3, title: "流转视频画质修复版，动态比截图更清楚", views: "今日 2.8 万" },
  { rank: 4, title: "访谈原声字幕版 · 画面之外的声音信息", views: "今日 2.2 万" },
  { rank: 5, title: "多机位并排比对 · 哪段才是原版", views: "今日 1.9 万" },
  { rank: 6, title: "视频截图独立成页，关键帧逐张放大", views: "今日 1.5 万" },
  { rank: 7, title: "漏网旧档高清补档，暗部细节完整", views: "今日 1.2 万" },
  { rank: 8, title: "反查来源指南 · 日期对不上就说明版本旧", views: "今日 9.4 千" },
];

export const faqItems = [
  {
    q: "九色黑料图片、九色黑料视频为什么被分成不同页面？",
    a: "把图片、视频和截图分开归档，是为了让画面细节更好定位。按题材和日期归组后，想找原图级画面的网友不用在长列表里反复下拉，点开对应分区就能直接看。",
  },
  {
    q: "怎么判断看到的到底是九色黑料截图还是完整画面？",
    a: "截图通常是单帧，边缘和动态信息会缺失；视频则保留连续动作。若截图细节与日期、场景对不上，很可能是压缩或旧版本，可直接到时间线页反查最新归档。",
  },
  {
    q: "同一批内容为什么有的清晰、有的模糊？",
    a: "流出内容往往经过多手压缩，清晰度取决于原始画质与转存次数。我们尽量保留更高解析度的批次，并把修复版单独标注，方便你对比原图细节。",
  },
  {
    q: "页面更新频率是怎样的？",
    a: "图片与视频按批次持续补入，截图与时间线随新内容同步刷新。首页头版与追更热榜会标记最近一次更新的时间，方便掌握最新动态。",
  },
  {
    q: "我该怎么从某一页快速翻到想看的那批画面？",
    a: "每页内容都按日期与题材分了组，顶部的导航与页内的分类入口可直接跳到对应分区。时间线页也会列出每次新增的目录，照着点即可直达。",
  },
  {
    q: "手机上浏览会不会卡顿或看不清细节？",
    a: "页面针对手机做了自适应，图片默认按可读尺寸呈现，需要时点开即可放大看原图级画面。建议在网络较好时浏览视频，以获得更流畅的动态体验。",
  },
];